// extracted by mini-css-extract-plugin
module.exports = {"root":"InventoryLicencesTable_root__38Xcq","quantity":"InventoryLicencesTable_quantity__13F5Y"};